import React, { useState, useEffect,useContext } from "react";
import { useLocation } from "react-router-dom";
import "@fontsource/ibm-plex-sans-arabic";
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/css/theme.css';
import Cookies from 'universal-cookie';
import OneSignal from 'react-onesignal'
import Header from "./components/layout/header";
import Footer from "./components/layout/footer";
import Routing from "./components/routing";
import { RouteContext } from "./contexts/route.context";
import { FirebaseContext } from "./contexts/firebase.context";

const App = () => {
  const cookies = new Cookies();
  let authToken = cookies.get('userTkn');
  const { getMe, me, generateRandomString, setNewDevice, LogOutUser } = useContext(RouteContext);
  let with_no_header_footer = ['login', 'verification', 'step1', 'step2', 'step3', 
    'login-lessor', 'verification-lessor', 'step1-lessor', 'step2-lessor', 'step3-lessor'];
  let _urlPath = window.location.pathname.replace("/", "");
  // let profile_qr_page = ['lessor-profile-qr']

  const { database } = useContext(FirebaseContext);
  let userCookie = cookies.get('userTkn');
  let phone = cookies.get('phoneNumber');
  let code = cookies.get('code');
  const current = new Date();
  const nextYear = new Date();
  const [userMe, setUserMe] = useState();
  const curUrl = window.location.href.toLowerCase();
  const [loading, setLoading] = useState(true)

  let curPath = useLocation();


  let urlAvoid = ["/step1-lessor", "/step2-lessor", "/step1-lessee", "/step2-lessee", "/login-lessor", "/login"];

  let isIncluded = urlAvoid.includes(curPath.pathname)
  
  useEffect(()=>{
    if(userCookie && isIncluded){
      window.location.href = "/"
    }
  },[])


  // useEffect(()=>{
  //   if(authToken && !phone){
  //     LogOutUser()
  //   }
  // },[])

  useEffect(() => {
    checkToken();
    registerOneSignal()
  }, []);

  const registerOneSignal = async () => {
    await OneSignal?.init({
      appId: process.env.REACT_APP_RENTER_ONESIGNAL_APP_ID,
      safari_web_id: "web.onesignal.auto.528b6caf-1e6b-4608-b4e6-faa03f146a9c",
      notifyButton: {
        enable: true,
      },
      // allowLocalhostAsSecureOrigin: true,
    })
  }

  const checkGetMe = async() => {
    
    let x = await getMe();

    if(!curUrl.includes("/step3-lessee") && x?.role.id === "4")
      {
        if(x?.name === null){
          if(x?.role.id === "4"){
            window.location.href = "/step3-lessee";
          }
          else{
            window.location.href = "/step3-lessor";
          }
        }
      }
      else if(!curUrl.includes("/step3-lessor") && x?.role.id === "3"){
        if(x?.name === null){
          if(x?.role.id === "3"){
            window.location.href = "/step3-lessor";
          }
          else{
            window.location.href = "/step3-lessee";
          }
        }
      }
    
    setUserMe(x);
    
    return x;
  }

  const checkToken = async () => {
    let x = await checkGetMe();
    if(x){
      setNewDevice(x.id, generateRandomString())
    }
    if (userCookie && !x){
      cookies.remove('userTkn', { path: '/' });
      cookies.remove('code', { path: '/' });
      cookies.remove('phoneNumber', { path: '/' });
      window.location.reload(false);
    }
    
    setLoading(false)
  }

  // useEffect(()=>{
  //     var OneSignal = window.OneSignal || [];
  //     OneSignal.init({
  //       appId: process.env.REACT_APP_RENTER_ONESIGNAL_APP_ID,
  //       safari_web_id: "web.onesignal.auto.528b6caf-1e6b-4608-b4e6-faa03f146a9c",
  //       notifyButton: {
  //         enable: true,
  //       },
  //     // allowLocalhostAsSecureOrigin: true,
  //     }).then(async ()=>{
  //       // await OneSignal.login(userMe?.id).catch((error) => {
  //       //   console.error("OneSignal login error: ", error);
  //       // });

  //       await OneSignal?.User?.addTags({
  //         userId: `userId_${userMe?.id}`, 
  //         // userType: result.data.data.login.user.role.id, 
  //         platform: "web"
  //       });
  //     });
  // },[userMe])


  useEffect(()=>{
    if (userCookie && userMe){

      nextYear.setFullYear(current.getFullYear() + 10);
      // cookies.set('code', code, {
      //   path: '/',
      //   expires: nextYear,
      // });
      cookies.set('phoneNumber', phone, {
        path: '/',
        expires: nextYear,
      });
      cookies.set('userTkn', userCookie, {
        path: '/',
        expires: nextYear,
      });
    }

  }, [current])


  return (
    <div>
      {
        loading ? 
        <div className="loader mt-4"></div>
        :
        authToken ? (
          userMe ? (
            <>
              {!with_no_header_footer.includes(_urlPath) && !_urlPath.includes('lessor-profile-public-qr') ? (
                <Header/>
              ) : null}
              
  
              <div className="content-div">
                <Routing/>
              </div>
  
              {!with_no_header_footer.includes(_urlPath) && !_urlPath.includes('lessor-profile-public-qr') ? (
                <Footer/>
              ) : null}
            </>
          ) : (
            <div className="wrap">
              <div className="loading">
                <div className="bounceball"></div>
                <div className="text">NOW LOADING</div>
              </div>
            </div>
          )
        ) : (
          <>
            {!with_no_header_footer.includes(_urlPath) && !_urlPath.includes('lessor-profile-public-qr') ? (
              <Header/>
            ) : null}
            
  
            <div className="content-div">
              <Routing/>
            </div>
  
            {!with_no_header_footer.includes(_urlPath) && !_urlPath.includes('lessor-profile-public-qr') ? (
              <Footer/>
            ) : null}
          </>
        )

      }
    </div>
  );
}

export default App;
